import { ManagerType } from "../../../types/Manager";
import { post } from "../../../utils/axios-config";
import { MANAGERS } from "../../../utils/constants";

export const createManager = async (data: ManagerType) => await post<ManagerType, string>(MANAGERS, data);